module.exports = __webpack_public_path__ + "img/0d797c6.svg";